const env = process.env.ENVIRONMENT !== 'PDN' ? 'DEV' : 'PDN'
export const LOCALE = process.env.LOCALE || 'es-CO'

const siteUrl =
  process.env.ENVIRONMENT === 'PDN'
    ? process.env.SITE_URL
    : process.env.ENVIRONMENT === 'STG'
    ? process.env.SITE_STG
    : process.env.SITE_DEV

// TODO: pendiente ajustar id de actividad
export const competitionId = {
  DEV: {
    'es-CO': 147,
    'es-AR': 148,
    'es-PE': 149,
    'es-EC': 150,
    'es-CL': 151,
    'es-DO': 152,
    'es-BO': 153,
    'es-PR': 154,
    'es-PY': 155,
    'es-UY': 156,
  },
  PDN: {
    'es-CO': 154,
    'es-AR': 155,
    'es-PE': 156,
    'es-EC': 157,
    'es-CL': 158,
    'es-BO': 159,
    'es-PY': 160,
    'es-UY': 161,
    'es-DO': 162,
    'es-PR': 163,
  },
}[env || 'development'][LOCALE || 'es-CO'] //Id Game Tren del Loving
export const countryActivity = { name: 'Colombia', contact: '018000 052 48 48' }
export const costActivity = {
  'es-CO': 25,
  'es-AR': 20,
  'es-PE': 20,
  'es-EC': 20,
  'es-CL': 20,
  'es-DO': 20,
  'es-BO': 0,
  'es-PR': 20,
  'es-PY': 20,
  'es-UY': 0,
}[LOCALE]
export const timesActivity = {
  'es-CO': {
    inicio: { dia: 23, mes: 'Enero', año: 2023 },
    fin: { dia: 8, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '18 y 21', mes: 'Marzo', año: 2023 },
  },
  'es-AR': {
    inicio: { dia: 1, mes: 'Febrero', año: 2023 },
    fin: { dia: 20, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '01 y 04', mes: 'Abril', año: 2023 },
  },
  'es-PE': {
    inicio: { dia: 1, mes: 'Febrero', año: 2023 },
    fin: { dia: 20, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '01 y 04', mes: 'Abril', año: 2023 },
  },
  'es-EC': {
    inicio: { dia: 1, mes: 'Febrero', año: 2023 },
    fin: { dia: 20, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '01 y 04', mes: 'Abril', año: 2023 },
  },
  'es-CL': {
    inicio: { dia: 15, mes: 'Febrero', año: 2023 },
    fin: { dia: 30, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '10 y 14', mes: 'Abril', año: 2023 },
  },
  'es-DO': {
    inicio: { dia: 15, mes: 'Febrero', año: 2023 },
    fin: { dia: 30, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '10 y 14', mes: 'Abril', año: 2023 },
  },
  'es-BO': {
    inicio: { dia: 8, mes: 'Febrero', año: 2023 },
    fin: { dia: 20, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '01 y 04', mes: 'Abril', año: 2023 },
  },
  'es-PR': {
    inicio: { dia: 15, mes: 'Febrero', año: 2023 },
    fin: { dia: 15, mes: 'Mayo', año: 2023 },
    ganadoras: { dia: '25 y 30', mes: 'Abril', año: 2023 },
  },
  'es-PY': {
    inicio: { dia: 8, mes: 'Febrero', año: 2023 },
    fin: { dia: 20, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '01 y 04', mes: 'Abril', año: 2023 },
  },
  'es-UY': {
    inicio: { dia: 8, mes: 'Febrero', año: 2023 },
    fin: { dia: 20, mes: 'Marzo', año: 2023 },
    ganadoras: { dia: '01 y 04', mes: 'Abril', año: 2023 },
  },
}[LOCALE]
export const numWinners = {
  'es-CO': 50,
  'es-AR': 5,
  'es-PE': 5,
  'es-EC': 3,
  'es-CL': 5,
  'es-DO': 5,
  'es-BO': 3,
  'es-PR': 5,
  'es-PY': 10,
  'es-UY': 0,
}[LOCALE]

export const activitySEO = {
  url: env === 'DEV' ? '' : `${siteUrl}/magazin/concursos/v-match-2023`,
  title: `Encuentra la pareja`,
  description: `Un juego con tus productos favoritos Nosotras para que pongas a prueba tu memoria, ganes premios y te diviertas.`,
}

// export const secondsLimitGame = 30
export const delayFlip = 500
export const pointsByMatch = 5
export const timeForLevels = [30, 50, 70, 90, 110]

export const matrixGame = {
  mobile: {
    0: [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    1: [
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [0, 0, 0, 0],
    ],
    2: [
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0],
    ],
    3: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 0, 0, 0],
    ],
    4: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 1, 1, 0],
    ],
    5: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [1, 1, 1, 1],
    ],
  },
  desktop: {
    0: [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    1: [
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [0, 0, 0, 0],
    ],
    2: [
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0],
    ],
    3: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 0, 0, 0],
    ],
    4: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 1, 1, 0],
    ],
    5: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [1, 1, 1, 1],
    ],
  },
}

export const imgProducts = {
  'es-CO': [
    require('./../assets/images/game/img1.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-EC': [
    require('./../assets/images/game/img1.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-PE': [
    require('./../assets/images/game/img1.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-AR': [
    require('./../assets/images/game/img1AR.png').default,
    require('./../assets/images/game/img2AR.png').default,
    require('./../assets/images/game/img3AR.png').default,
    require('./../assets/images/game/img4AR.png').default,
    require('./../assets/images/game/img5AR.png').default,
    require('./../assets/images/game/img6AR.png').default,
  ],
  'es-CL': [
    require('./../assets/images/game/img1CL.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-DO': [
    require('./../assets/images/game/img1.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-BO': [
    require('./../assets/images/game/img1BO.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-PR': [
    require('./../assets/images/game/img1PR.png').default,
    require('./../assets/images/game/img2.png').default,
    require('./../assets/images/game/img3.png').default,
    require('./../assets/images/game/img4.png').default,
    require('./../assets/images/game/img5.png').default,
    require('./../assets/images/game/img6.png').default,
  ],
  'es-PY': [
    require('./../assets/images/game/img1AR.png').default,
    require('./../assets/images/game/img2AR.png').default,
    require('./../assets/images/game/img3AR.png').default,
    require('./../assets/images/game/img4AR.png').default,
    require('./../assets/images/game/img5AR.png').default,
    require('./../assets/images/game/img6AR.png').default,
  ],
  'es-UY': [
    require('./../assets/images/game/img1AR.png').default,
    require('./../assets/images/game/img2AR.png').default,
    require('./../assets/images/game/img3AR.png').default,
    require('./../assets/images/game/img4AR.png').default,
    require('./../assets/images/game/img5AR.png').default,
    require('./../assets/images/game/img6AR.png').default,
  ],
}[LOCALE]
